<template>
    <div class="c-service-users">
        <div class="inner-content full">
            <div v-if="!isSuperAdmin">
                U heeft geen toegang tot deze pagina
            </div>
            <div v-else>
                <div class="menu">
                    <router-link class="btn-basic small blue" to="/shop-admin">Winkels</router-link> |
                    <span>Service Users</span>
                </div>
                <div class="user-list">
                    <div v-for="user in users" :key="user.id" class="user">
                        <div class="name">
                            {{ user.name }}
                        </div>
                        <div class="email">
                            {{ user.email }}
                        </div>
                        <div class="action">
                            <button class="btn-delete-user btn-basic small red" @click.prevent="deleteUser(user)">wissen</button>
                        </div>
                    </div>
                </div>
                <div class="create-user">
                    <div class="title">Service User aanmaken</div>
                    <div class="formfield">
                        <label for="">naam</label>
                        <input type="text" class="inputfield" placeholder="naam" v-model="name"/>
                    </div>
                    <div class="formfield">
                        <label for="">E-mail</label>
                        <input type="text" class="inputfield" placeholder="email" v-model="email"/>
                    </div>
                    <div class="formfield">
                        <label for="">Wachtwoord</label>
                        <input type="password" class="inputfield" placeholder="password" v-model="password"/>
                    </div>
                    <div v-if="error" class="form-error">
                        {{ error }}
                    </div>
                    <div>
                        <button class="btn-basic blue small" @click.prevent="createUser">Aanmaken</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="popup" v-if="userToDelete != null">
            <div class="popup-content">
                <div class="title">
                    Wil je deze gebruiker verwijderen?
                </div>
                <div class="buttons">
                    <button @click.prevent="cancelDeleteUser" class="btn-basic small bordered">annuleren</button>
                    <button @click.prevent="confirmDeleteUser" class="btn-basic small red">wissen</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {apiStore} from "@/stores/api";
import {isValidEmail} from "@/utils/utils.js";

export default {
    data() {
        return {
            users: [],
            name: "",
            email: "",
            password: "",
            error: false,
            userToDelete: null
        };
    },

    created() {
        this.fetchServiceUsers();
    },

    computed: {
        isSuperAdmin() {
            return apiStore().loggedInUser !== null && apiStore().loggedInUser.role === "superadmin";
        }
    },

    methods: {
        async fetchServiceUsers() {
            const response = await apiStore().getServiceUsers();
            this.users = response;
        },

        async createUser() {
            this.error = false;
            if (!isValidEmail(this.email)) {
                this.error = "Ongeldig e-mailadres";
                return;
            }
            if (this.name === "") {
                this.error = "Naam is verplicht";
                return;
            }

            if (this.password.length < 8) {
                this.error = "Wachtwoord moet minimaal 8 tekens bevatten";
                return;
            }
            const data = {
                name: this.name,
                email: this.email,
                password: this.password
            };
            const response = await apiStore().createServiceUser(data);
            if (response.id) {
                this.fetchServiceUsers();
                this.name = "";
                this.email = "";
                this.password = "";
            } else {
                this.error = response.error;
            }
        },

        deleteUser(user) {
            this.userToDelete = user;
        },

        async confirmDeleteUser() {
            await apiStore().deleteUser(this.userToDelete.id);
            this.userToDelete = null;

            await this.fetchServiceUsers();
        },

        cancelDeleteUser() {
            this.userToDelete = null;
        }
    }
};
</script>

<style lang="scss" scoped>
.c-service-users {
    input[type=text].inputfield,
    input[type=password].inputfield {
        height : 2rem;
        font-size: 1em;
        width : 20rem;
    }

    .create-user {
        margin-top : 2rem;
    }

    .user {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;

        .name {
            width : 10rem;
        }

        .email {
            width : 20rem;
        }

        .action {
            width : 10rem;
            text-align: right;
        }
    }

    .title {
        font-size : 1em;
        font-weight : bold;
        margin-bottom: .5rem;
    }

    .formfield {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;

        label {
            width : 6rem;
            margin-right : 1rem;
        }

        input {
            margin-bottom: 0;
        }
    }

    .form-error {
        color : $color-red;
        margin-bottom : 0.5rem;
    }

    .menu {
        margin-bottom : 1rem;

        span {
            font-weight: bold;
        }

        a {
            background: transparent;
            color: black;
            border: none;
            padding: 0;
            text-decoration: underline;
            font-size: 1em;
        }
    }

    .user-list {
        max-height: 15rem;
        overflow-y: scroll;
        width: 40rem;
    }

    .popup {
        position: absolute;
        background : rgba(255, 255, 255,.8);
        top : 0;
        left : 0;
        right : 0;
        bottom : 0;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;

        .buttons {
            .btn-basic {
                margin : 1rem;
            }
        }
    }
}
</style>